
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

interface CountyData {
  id: string;
  name: string;
  slug: string;
  description: string | null;
  image_url: string | null;
  nursing_home_count: number;
  featured: boolean;
  display_order: number;
  updated_at: string;
}

export function useCountyData(countySlug: string | undefined) {
  return useQuery({
    queryKey: ["county-data", countySlug],
    queryFn: async () => {
      if (!countySlug) return null;
      
      try {
        console.log(`Fetching data for county: ${countySlug}`);
        
        const { data, error } = await supabase
          .from("counties")
          .select("*")
          .eq("slug", countySlug)
          .single();
          
        if (error) {
          console.error("Error fetching county data:", error);
          toast.error("Failed to load county information");
          throw error;
        }
        
        console.log("County data retrieved:", data);
        return data as CountyData;
      } catch (err) {
        console.error("Error in county data query:", err);
        toast.error("Could not load county information");
        throw err;
      }
    },
    enabled: !!countySlug,
  });
}
